import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import TelegramIcon from '@mui/icons-material/Telegram';
import CalculateIcon from '@mui/icons-material/Calculate';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Box, Card, Chip, Container, Grid, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LandingAboutSection from './LandingAboutSection';
import LandingHeader from './LandingHeader';
import LandingProcessCarousel from './LandingProcessCarousel';

const featureCards = [
  { icon: PersonIcon, titleKey: 'landing.feature.client.title', descKey: 'landing.feature.client.desc' },
  { icon: Inventory2Icon, titleKey: 'landing.feature.movement.title', descKey: 'landing.feature.movement.desc' },
  { icon: CalendarMonthIcon, titleKey: 'landing.feature.daily.title', descKey: 'landing.feature.daily.desc' },
  { icon: NotificationsActiveIcon, titleKey: 'landing.feature.reminders.title', descKey: 'landing.feature.reminders.desc' },
  { icon: StorefrontIcon, titleKey: 'landing.feature.branches.title', descKey: 'landing.feature.branches.desc' },
  { icon: TelegramIcon, titleKey: 'landing.feature.telegram.title', descKey: 'landing.feature.telegram.desc' }
];

export default function LandingPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('Dastur haqida')} | System 24</title>
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(180deg, #eef4ff 0%, #f8fbff 42%, #ffffff 100%)'
        }}>
        <LandingHeader />

        <Container maxWidth="lg" sx={{ py: { xs: 2, md: 3 } }}>
          <LandingProcessCarousel />

          <Stack spacing={1.5} sx={{ mb: { xs: 5, md: 8 }, maxWidth: 900 }}>
            <Chip
              label={t('landing.hero.badge')}
              size="small"
              sx={{
                alignSelf: { xs: 'center', md: 'flex-start' },
                bgcolor: 'background.paper',
                fontWeight: 600,
                px: 1
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: '1.5rem', md: '2rem' },
                lineHeight: 1.2,
                textAlign: { xs: 'center', md: 'left' }
              }}>
              {t('landing.hero.title')}
            </Typography>

            <Stack direction="row" flexWrap="wrap" gap={1} justifyContent={{ xs: 'center', md: 'flex-start' }}>
              <Chip size="small" icon={<CalculateIcon />} label={t('landing.hero.pill.contract')} />
              <Chip size="small" icon={<AccountBalanceWalletIcon />} label={t('landing.hero.pill.deposit')} />
              <Chip size="small" icon={<Inventory2Icon />} label={t('landing.hero.pill.movement')} />
              <Chip size="small" icon={<NotificationsActiveIcon />} label={t('landing.hero.pill.reminders')} />
            </Stack>
          </Stack>

          <Typography variant="h4" textAlign="center" fontWeight={700} sx={{ mb: 4 }}>
            {t('landing.features.title')}
          </Typography>

          <Grid container spacing={3} sx={{ mb: 2 }}>
            {featureCards.map(({ icon: Icon, titleKey, descKey }) => (
              <Grid item xs={12} sm={6} md={4} key={titleKey}>
                <Card
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: 3,
                    boxShadow: '0 10px 30px rgba(32, 101, 209, 0.08)'
                  }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'primary.lighter',
                      color: 'primary.main',
                      mb: 2
                    }}>
                    <Icon />
                  </Box>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {t(titleKey)}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(descKey)}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>

          <LandingAboutSection />
        </Container>
      </Box>
    </>
  );
}
